import React from 'react';
import { Fieldset } from '~/components/FormControl';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CheckboxGroup from '~/components/CheckboxGroup';
import classNames from 'classnames/bind';
const cx = classNames.bind();
function ActiveTurns({ smCol, smCheckbox, className }) {
    const roundLists = [
        { id: 1, name: 'Turn 1' },
        { id: 2, name: 'Turn 2' },
        { id: 3, name: 'Turn 3' },
        { id: 4, name: 'Turn 4' },
        { id: 5, name: 'Turn 5' },
    ];

    return (
        <Col
            sm={smCol}
            className={cx('d-flex')}
        >
            <Fieldset
                className={'px-4'}
                fieldsetStyle={{ flexGrow: 1 }}
            >
                <Fieldset.Legend>Active Turns:</Fieldset.Legend>
                <CheckboxGroup
                    options={roundLists}
                    fieldName="activeTurns"
                    sm={smCheckbox}
                    className={className}
                />
            </Fieldset>
        </Col>
    );
}

ActiveTurns.defaultProps = {
    smCol: 6,
    smCheckbox: null,
    className: null,
};

ActiveTurns.propTypes = {
    className: PropTypes.string,
    smCol: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    smCheckbox: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ActiveTurns;
